import { render, staticRenderFns } from "./audio_upload.vue?vue&type=template&id=c3653e70&scoped=true&"
import script from "./audio_upload.vue?vue&type=script&lang=js&"
export * from "./audio_upload.vue?vue&type=script&lang=js&"
import style0 from "./audio_upload.vue?vue&type=style&index=0&id=c3653e70&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3653e70",
  null
  
)

export default component.exports